import type { AlertColor } from "@mui/material";
import { Alert, AlertTitle, Stack, Typography } from "@mui/material";

interface Props {
  severity: AlertColor;
  title: string;
  lines: string[];
}

const ArtifactAgentNote = ({ severity, title, lines }: Props) => (
  <Alert severity={severity}>
    <AlertTitle>{title}</AlertTitle>
    <Stack spacing={0.5}>
      {lines.map((line, index) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <Typography key={index} sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>
          {line}
        </Typography>
      ))}
    </Stack>
  </Alert>
);

export default ArtifactAgentNote;
